import React from 'react'
import {
  Container,
  Paper,
  Box,
  Typography
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import ResetForm from 'components/organisms/resetPassword'

const Reset = () => {
  const { t } = useTranslation()

  const getRandomSubtitle = (subtitles) => {
    return subtitles[Math.floor(Math.random() * subtitles.length)];
  };

  const subtitles = [
    "Regain access to your workspace",
    "Reset your password, reclaim your productivity",
    "Secure access, seamless work",
    "Your professional journey continues",
    "Unlock your workspace potential"
  ];

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 200px)',
        py: 4
      }}
    >
      <Paper
        elevation={3}
        sx={{
          width: {
            xs: 'calc(100% - 20px)',  // Full width minus margins on mobile
            sm: 'calc(100% - 40px)',   // Slightly different on small screens
            md: 450,                   // Fixed width on medium and up
            lg: 450                    // Consistent on large screens
          },
          maxWidth: {
            xs: 'none',                // No max-width on mobile
            md: 450                    // Max width on desktop
          },
          margin: 'auto',               // Center the paper
          p: {
            xs: 2,                      // Less padding on mobile
            md: 4                       // More padding on desktop
          },
          borderRadius: 2
        }}
      >
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="h4"
            color="primary"
            sx={{ fontWeight: 700, mb: 1 }}
          >
            {t('reset.title')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {getRandomSubtitle(subtitles)}
          </Typography>
        </Box>

        <ResetForm />
      </Paper>
    </Container>
  )
}

export default Reset